import { DomainView } from "@/components/domain";
import { Badge } from "@/components/ui/badge";
import { useSheetContext } from "@/context/sheet";
import { useDeleteGuide, useGetGuide } from "@/hooks/guides";
import { T } from "@/i18n";
import { formatPhoneNumber } from "@/lib/utils";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { format } from "date-fns";
import { Key } from "react";

export const Route = createFileRoute("/(guides)/guides/_sheet/$id/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data, isLoading } = useGetGuide(id);
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutate: deleteGuide } = useDeleteGuide({
    onSuccess: () => {
      close(() => {
        navigate({ to: "/guides" });
      });
    },
  });

  return (
    <DomainView
      domain="guides"
      editLink={(children, key) => (
        <Link to="/guides/$id/edit" params={{ id }} key={key as Key}>
          {children}
        </Link>
      )}
      isLoading={isLoading}
      title={data?.name}
      onDelete={() => deleteGuide(id)}
      propsList={[
        {
          title: "guides.fields.email",
          value: data?.email ?? "-",
        },
        {
          title: "guides.fields.phone",
          value: formatPhoneNumber(data?.phone),
        },
        {
          title: "guides.fields.birthdate",
          value: data?.birthdate
            ? format(new Date(data.birthdate), "PPP")
            : "-",
        },
        {
          title: "guides.fields.country",
          value: data?.country ? <T tKey={`countries.${data.country}`} /> : "-",
        },
        {
          title: "guides.fields.language",
          value: data?.language?.length ? (
            <div className="flex items-center gap-1">
              {data.language?.map((l) => <Badge key={l}>{l}</Badge>)}
            </div>
          ) : (
            "-"
          ),
        },
      ]}
    />
  );
}
